(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-lead-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-bf-countdown]').forEach((el) => {
    const end = new Date(el.dataset.bfCountdown.replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const diff = end - Date.now();
      if (diff <= 0) { el.hidden = true; return; }
      el.hidden = false;
      const parts = { d: Math.floor(diff / 864e5), h: Math.floor(diff / 36e5) % 24, m: Math.floor(diff / 6e4) % 60, s: Math.floor(diff / 1e3) % 60 };
      Object.entries(parts).forEach(([k, v]) => { const n = el.querySelector(`[data-unit="${k}"]`); if (n) n.textContent = pad(v); });
    };
    tick();
    setInterval(tick, 1000);
  });

  document.querySelectorAll('[data-bf-sticky]').forEach((btn) => {
    const target = document.querySelector(btn.getAttribute('href'));
    const finalForm = btn.closest('.bf')?.querySelector('.bf-final');
    if (!target || !('IntersectionObserver' in window)) return;
    let heroVisible = true;
    let finalVisible = false;
    const update = () => btn.classList.toggle('is-visible', !heroVisible && !finalVisible);
    new IntersectionObserver(([e]) => { heroVisible = e.isIntersecting; update(); }).observe(target);
    if (finalForm) new IntersectionObserver(([e]) => { finalVisible = e.isIntersecting; update(); }).observe(finalForm);
  });

  if (location.search.includes('customer_posted=true')) {
    const root = document.querySelector('[data-bf-thankyou]');
    // Só redireciona quando foi um dos formulários desta página (não a newsletter do rodapé).
    const fromBfForm = !location.hash || location.hash.startsWith('#BF');
    if (root && fromBfForm && !window.Shopify?.designMode) {
      // A marca no link permite à página de obrigado contar o registo só nesta visita (CompleteRegistration).
      const url = root.dataset.bfThankyou;
      location.replace(url + (url.includes('?') ? '&' : '?') + 'inscricao=ok');
      return;
    }
    document.querySelector('.bf-form__success')?.scrollIntoView({ block: 'center' });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dr-pack-promo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-dr-pack-link]');
  if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const selector = document.querySelector('pack-selector');
  if (!selector) return;
  event.preventDefault();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: selector.getBoundingClientRect().top + window.scrollY - 120, behavior: reduced ? 'instant' : 'smooth' });
  selector.querySelector('input[type="radio"]:checked')?.focus({ preventScroll: true });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dr-video-carousel')) {
  customElements.define('dr-video-carousel', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.video-testimonials__scroller');
      this.cards = [...this.querySelectorAll('.video-testimonials__card')];
      this.controls = this.querySelector('.dr-video-controls');
      this.previous = this.querySelector('[data-video-prev]');
      this.next = this.querySelector('[data-video-next]');
      this.counter = this.querySelector('.dr-video-count');
      this.progress = this.querySelector('.dr-video-progress');
      this.events = new AbortController();
      const signal = this.events.signal;
      this.previous.addEventListener('click', () => this.step(-1), { signal });
      this.next.addEventListener('click', () => this.step(1), { signal });
      this.scroller.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, { passive: true, signal });
      this.scroller.addEventListener('keydown', event => {
        if (event.target !== this.scroller || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.maxScroll());
        else this.step(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      const pauseOthers = event => {
        if (this.hasAttribute('data-autoplay')) return;
        const current = event.target.closest('video-element');
        this.querySelectorAll('video-element').forEach(video => { if (video !== current) video.pause?.(); });
      };
      this.addEventListener('play', pauseOthers, { capture: true, signal });
      this.addEventListener('video:play', pauseOthers, { signal });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.video-testimonials__card');
        if (card) this.go(this.cardOffset(card));
      }, { signal });
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.scroller);
      this.cards.forEach(card => this.resize.observe(card));
      this.update();
    }
    maxScroll() { return Math.max(0, this.scroller.scrollWidth - this.scroller.clientWidth); }
    cardOffset(card) { return card.getBoundingClientRect().left - this.scroller.getBoundingClientRect().left + this.scroller.scrollLeft; }
    go(left) {
      this.scroller.scrollTo({ left: Math.max(0, Math.min(left, this.maxScroll())), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
    }
    step(direction) {
      const position = this.scroller.scrollLeft;
      const stops = [...new Set(this.cards.map(card => Math.round(Math.min(this.cardOffset(card), this.maxScroll()))))];
      const target = direction > 0 ? stops.find(stop => stop > position + 2) : stops.reverse().find(stop => stop < position - 2);
      if (target !== undefined) this.go(target);
    }
    update() {
      const maximum = this.maxScroll();
      const position = this.scroller.scrollLeft;
      this.controls.hidden = maximum <= 2;
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= maximum - 2;
      const bounds = this.scroller.getBoundingClientRect();
      const visible = [];
      this.cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        if (rect.right > bounds.left + 4 && rect.left < bounds.right - 4) visible.push(index + 1);
        else card.querySelector('video-element')?.pause?.();
      });
      if (visible.length) {
        const range = visible.length === 1 ? visible[0] : `${visible[0]}–${visible[visible.length - 1]}`;
        this.counter.textContent = `${range} / ${this.cards.length}`;
      }
      const fraction = maximum ? (position + this.scroller.clientWidth) / this.scroller.scrollWidth : 1;
      this.progress.style.setProperty('--video-progress', Math.max(0, Math.min(1, fraction)));
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.querySelectorAll('video-element').forEach(video => video.pause?.());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
